document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('nl-popup');
  if (!popup) return;

  var overlay = document.getElementById('nl-popup-overlay');
  var modal = document.getElementById('nl-popup-modal');
  var closeBtn = document.getElementById('nl-popup-close');
  var tabBtn = document.getElementById('nl-popup-tab');

  var STORAGE_KEY = 'aiw_newsletter_popup_hidden_until';
  var delaySeconds = parseInt(popup.getAttribute('data-delay'), 10) || 0;
  var hideDays = parseInt(popup.getAttribute('data-hide-days'), 10) || 14;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isSuppressed() {
    try {
      var until = localStorage.getItem(STORAGE_KEY);
      return until && Date.now() < parseInt(until, 10);
    } catch (e) {
      return false;
    }
  }

  function suppressFor(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {
      /* ignore storage errors (private browsing, etc.) */
    }
  }

  function openPopup() {
    if (overlay) overlay.classList.add('is-open');
    if (modal) modal.classList.add('is-open');
  }

  function closePopup(remember) {
    if (overlay) overlay.classList.remove('is-open');
    if (modal) modal.classList.remove('is-open');
    if (remember) suppressFor(hideDays);
  }

  // If the form was just submitted successfully, the page reloads with a
  // success message inside the modal — force it open so the customer sees it.
  var justSubscribed = !!document.getElementById('nl-popup-success');

  if (justSubscribed) {
    openPopup();
    suppressFor(hideDays);
  } else if (!isSuppressed() && !isMobile()) {
    // Desktop: pop out automatically after the configured delay
    setTimeout(openPopup, delaySeconds * 1000);
  }
  // Mobile: never auto-opens — only via the side tab, regardless of suppression,
  // so it's always available if someone wants to open it manually.

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closePopup(true);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closePopup(true);
    });
  }

  if (tabBtn) {
    tabBtn.addEventListener('click', function () {
      openPopup();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup(true);
  });
});
